"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableFaxNumber = exports.enableFullnameRemarks = void 0;
/* ========================================================================
    Module: Enable fullname remarks
 ========================================================================== */
/**
 * 氏名表記に関する備考のチェックによって入力フォームを有効／無効化する
 *
 * @returns {void}
 */
const enableFullnameRemarks = () => {
    const isFullnameRemarksElement = document.querySelector(".js-is-fullname-remarks");
    const fullnameRemarksElement = document.querySelector(".js-fullname-remarks");
    if (!isFullnameRemarksElement || !fullnameRemarksElement) {
        return;
    }
    enableIfChecked(isFullnameRemarksElement, fullnameRemarksElement, true);
};
exports.enableFullnameRemarks = enableFullnameRemarks;
/**
 * FAX番号のチェックによって入力フォームを有効／無効化する
 *
 * @returns {void}
 */
const enableFaxNumber = () => {
    const isFaxNumberElement = document.querySelector(".js-is-fax-number");
    const faxNumberElement = document.querySelector(".js-fax-number");
    if (!isFaxNumberElement || !faxNumberElement) {
        return;
    }
    enableIfChecked(isFaxNumberElement, faxNumberElement, false);
};
exports.enableFaxNumber = enableFaxNumber;
/**
 * チェックボックスのチェックによって入力フォームを有効／無効化する
 *
 * @param {HTMLInputElement} checkbox
 * @param {HTMLInputElement} target
 * @param {boolean} isDisabled  チェックした時に有効にする: true
 * @returns {void}
 */
const enableIfChecked = (checkbox, target, isDisabled) => {
    if (checkbox.type !== "checkbox") {
        return;
    }
    target.disabled = isDisabled;
    target.style.display = isDisabled ? "none" : "inline-block";
    checkbox.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement)) {
            return;
        }
        target.disabled = isDisabled;
        target.style.display = isDisabled ? "none" : "inline-block";
        if (e.currentTarget.checked) {
            target.disabled = !isDisabled;
            target.style.display = !isDisabled ? "none" : "inline-block";
        }
    });
    checkbox.dispatchEvent(new Event("change"));
};
